import { amplitude } from './client';
import type { AmplitudeEventName, AmplitudeEvents } from './types';

export const trackEvent = <T extends AmplitudeEventName>(name: T, props: AmplitudeEvents[T]): void => {
  // Only track if amplitude is available (user has consented to analytics)
  if (amplitude && typeof amplitude.track === 'function') {
    amplitude.track(name, props);
  }
};
